document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  const DURATION = 250;
  const MQ = window.matchMedia("(max-width: 575px)");

  let accordionInitialized = false;

  const getHeadings = () =>
    Array.from(document.querySelectorAll(".footer-accordion .heading-accordion"));

  function slideUp(el, duration = DURATION) {
    if (!el) return;
    // if already hidden, do nothing
    if (getComputedStyle(el).display === "none") return;

    el.style.overflow = "hidden";
    el.style.height = el.scrollHeight + "px";
    el.offsetHeight; // reflow
    el.style.transition = `height ${duration}ms`;
    el.style.height = "0px";

    window.setTimeout(() => {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
    }, duration);
  }

  function slideDown(el, duration = DURATION) {
    if (!el) return;

    el.style.removeProperty("display");
    let display = getComputedStyle(el).display;
    if (display === "none") display = "block";
    el.style.display = display;

    const height = el.scrollHeight;

    el.style.overflow = "hidden";
    el.style.height = "0px";
    el.offsetHeight; // reflow
    el.style.transition = `height ${duration}ms`;
    el.style.height = height + "px";

    window.setTimeout(() => {
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
    }, duration);
  }

  function onHeadingClick(e) {
    const heading = e.currentTarget;
    const accordion = heading.closest(".footer-accordion");
    const panel = heading.nextElementSibling;
    if (!accordion || !panel) return;

    accordion.classList.toggle("open");

    if (!accordion.classList.contains("open")) {
      slideUp(panel);
    } else {
      slideDown(panel);
    }
  }

  function footerAccordionInit() {
    // bind once
    getHeadings().forEach((h) => {
      h.addEventListener("click", onHeadingClick);
    });
  }

  function footerAccordionDestroy() {
    // unbind
    getHeadings().forEach((h) => {
      h.removeEventListener("click", onHeadingClick);

      const accordion = h.closest(".footer-accordion");
      const panel = h.nextElementSibling;

      accordion?.classList.remove("open");
      panel?.removeAttribute("style");
    });
  }

  function handleAccordion() {
    if (MQ.matches) {
      if (!accordionInitialized) {
        footerAccordionInit();
        accordionInitialized = true;
      }
    } else {
      if (accordionInitialized) {
        footerAccordionDestroy();
        accordionInitialized = false;
      } else {
        // even if not initialized, still ensure clean desktop state
        getHeadings().forEach((h) => {
          h.closest(".footer-accordion")?.classList.remove("open");
          h.nextElementSibling?.removeAttribute("style");
        });
      }
    }
  }

  handleAccordion();
  window.addEventListener("resize", handleAccordion);
});


